export default __webpack_public_path__ + "static/investment-image-4-652c153354eacb7332cb4e21cb6eb280.jpg";